import React from 'react';
import styled from 'styled-components';

const ReturnsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px;
  min-height: 70vh;
`;

const Title = styled.h1`
  text-align: center;
  color: #333;
  margin-bottom: 20px;
  font-size: 2.5rem;
  font-weight: 700;
`;

const Subtitle = styled.p`
  text-align: center;
  color: #666;
  margin-bottom: 60px;
  font-size: 1.2rem;
  max-width: 800px;
  margin: 0 auto 60px;
`;

const Section = styled.div`
  margin-bottom: 50px;
  background: #f8f9fa;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
`;

const SectionTitle = styled.h2`
  color: #4CAF50;
  margin-bottom: 25px;
  font-size: 1.8rem;
  font-weight: 600;
`;

const SectionContent = styled.div`
  color: #555;
  line-height: 1.8;
  font-size: 1.1rem;
`;

const DefinitionsList = styled.div`
  margin-top: 20px;
`;

const DefinitionItem = styled.div`
  margin-bottom: 20px;
  padding: 20px;
  background: white;
  border-radius: 10px;
  border-left: 4px solid #4CAF50;
`;

const DefinitionTerm = styled.strong`
  color: #333;
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
`;

const DefinitionDesc = styled.p`
  color: #666;
  margin: 0;
  line-height: 1.6;
`;

const ProcessStep = styled.div`
  margin-bottom: 25px;
  padding: 25px;
  background: white;
  border-radius: 10px;
  border-left: 4px solid #4CAF50;
`;

const StepNumber = styled.span`
  display: inline-block;
  width: 30px;
  height: 30px;
  background: #4CAF50;
  color: white;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  font-weight: bold;
  margin-right: 15px;
`;

const StepTitle = styled.h3`
  color: #333;
  margin-bottom: 15px;
  font-size: 1.3rem;
  display: flex;
  align-items: center;
`;

const StepContent = styled.div`
  color: #666;
  line-height: 1.6;
  margin-left: 45px;
`;

const RequiredList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 20px 0;
`;

const RequiredItem = styled.li`
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  color: #555;
  display: flex;
  align-items: flex-start;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:before {
    content: "✓";
    color: #4CAF50;
    font-weight: bold;
    margin-right: 10px;
    margin-top: 2px;
  }
`;

const ConditionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 30px;
`;

const ConditionCard = styled.div`
  background: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const ConditionIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #4CAF50, #45a049);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  margin: 0 auto 20px;
`;

const ConditionTitle = styled.h3`
  color: #333;
  margin-bottom: 15px;
  font-size: 1.3rem;
`;

const ConditionDescription = styled.p`
  color: #666;
  line-height: 1.6;
`;

const ImportantNote = styled.div`
  background: linear-gradient(135deg, #FF9800, #f57c00);
  color: white;
  padding: 30px;
  border-radius: 15px;
  margin-top: 40px;
`;

const NoteTitle = styled.h3`
  margin-bottom: 15px;
  font-size: 1.4rem;
`;

const NoteText = styled.p`
  line-height: 1.6;
  margin: 0;
`;

const ContactInfo = styled.div`
  background: #f8f9fa;
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  margin-top: 40px;
`;

const ContactTitle = styled.h3`
  color: #333;
  margin-bottom: 20px;
  font-size: 1.4rem;
`;

const ContactItem = styled.div`
  margin-bottom: 15px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const ContactLabel = styled.span`
  color: #555;
  margin-right: 10px;
`;

const ContactValue = styled.span`
  color: #4CAF50;
  font-weight: 600;
`;

const Returns = () => {
  return (
    <ReturnsContainer>
      <Title>Политика возврата</Title>
      <Subtitle>
        Подробная информация о порядке и условиях возврата товаров
      </Subtitle>

      <Section>
        <SectionTitle>1. Термины и определения</SectionTitle>
        <SectionContent>
          <p>
            В настоящей Политике возврата следующие слова и выражения имеют указанные значения:
          </p>
          <DefinitionsList>
            <DefinitionItem>
              <DefinitionTerm>Администрация</DefinitionTerm>
              <DefinitionDesc>
                Общество с ограниченной ответственностью «Лагом Лайф» (ИНН 6318073403, 
                местонахождение: 446301, Самарская область, г. Отрадный, Спортивная ул., д. 7)
              </DefinitionDesc>
            </DefinitionItem>
            <DefinitionItem>
              <DefinitionTerm>Сайт</DefinitionTerm>
              <DefinitionDesc>
                Содержимое интернет-страниц, расположенных в сети Интернет по адресу: https://foodstar.pro
              </DefinitionDesc>
            </DefinitionItem>
            <DefinitionItem>
              <DefinitionTerm>Пользователи</DefinitionTerm>
              <DefinitionDesc>
                Физические лица (в том числе представители юридических лиц и индивидуальные предприниматели), 
                обладающие возможностью использовать Сайт
              </DefinitionDesc>
            </DefinitionItem>
            <DefinitionItem>
              <DefinitionTerm>Товар</DefinitionTerm>
              <DefinitionDesc>
                Продукция, представленная на Сайте и доступная для приобретения
              </DefinitionDesc>
            </DefinitionItem>
          </DefinitionsList>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>2. Порядок возврата</SectionTitle>
        <SectionContent>
          <ProcessStep>
            <StepTitle>
              <StepNumber>1</StepNumber>
              Подача заявления
            </StepTitle>
            <StepContent>
              <p>
                Для возврата денежных средств Пользователь направляет Заявление о возврате денежных средств.
              </p>
              <p><strong>Заявление обязательно должно содержать:</strong></p>
              <RequiredList>
                <RequiredItem>ФИО Пользователя</RequiredItem>
                <RequiredItem>Обратный адрес</RequiredItem>
                <RequiredItem>Контактный телефон</RequiredItem>
                <RequiredItem>Наименование оплаченного Товара</RequiredItem>
                <RequiredItem>Дата оплаты Товара</RequiredItem>
                <RequiredItem>Подтверждение оплаты Товара (квитанция, выписка со счета и т.д.)</RequiredItem>
                <RequiredItem>Описание причин возврата</RequiredItem>
                <RequiredItem>Способ возврата (перечисление денежных средств на карту)</RequiredItem>
              </RequiredList>
            </StepContent>
          </ProcessStep>

          <ProcessStep>
            <StepTitle>
              <StepNumber>2</StepNumber>
              Рассмотрение заявления
            </StepTitle>
            <StepContent>
              <p>
                Администрация рассматривает Заявление о возврате в течение <strong>10 календарных дней</strong> 
                с момента получения, проверяя:
              </p>
              <RequiredList>
                <RequiredItem>Соответствие условиям возврата</RequiredItem>
                <RequiredItem>Полноту и достоверность предоставленной информации</RequiredItem>
                <RequiredItem>Достаточность документов для обработки</RequiredItem>
              </RequiredList>
            </StepContent>
          </ProcessStep>

          <ProcessStep>
            <StepTitle>
              <StepNumber>3</StepNumber>
              Принятие решения
            </StepTitle>
            <StepContent>
              <p>
                После рассмотрения заявления Администрация принимает одно из решений:
              </p>
              <ConditionsGrid>
                <ConditionCard>
                  <ConditionIcon>✅</ConditionIcon>
                  <ConditionTitle>Решение о возврате</ConditionTitle>
                  <ConditionDescription>
                    При соблюдении всех условий возврата и корректности предоставленной информации
                  </ConditionDescription>
                </ConditionCard>
                <ConditionCard>
                  <ConditionIcon>❌</ConditionIcon>
                  <ConditionTitle>Решение об отказе</ConditionTitle>
                  <ConditionDescription>
                    При несоблюдении условий возврата или некорректности предоставленных данных
                  </ConditionDescription>
                </ConditionCard>
              </ConditionsGrid>
            </StepContent>
          </ProcessStep>

          <ProcessStep>
            <StepTitle>
              <StepNumber>4</StepNumber>
              Возврат средств
            </StepTitle>
            <StepContent>
              <p>
                При положительном решении денежные средства возвращаются одним из способов:
              </p>
              <RequiredList>
                <RequiredItem>Перечисление на карту по реквизитам, указанным в заявлении</RequiredItem>
                <RequiredItem>Получение лично в кассе Администрации</RequiredItem>
              </RequiredList>
            </StepContent>
          </ProcessStep>
        </SectionContent>
      </Section>

      <Section>
        <SectionTitle>3. Условия возврата</SectionTitle>
        <SectionContent>
          <ConditionsGrid>
            <ConditionCard>
              <ConditionIcon>⏰</ConditionIcon>
              <ConditionTitle>Сроки возврата</ConditionTitle>
              <ConditionDescription>
                Товар можно вернуть в любое время до получения, в момент передачи или 
                в течение 7 календарных дней после получения
              </ConditionDescription>
            </ConditionCard>
            <ConditionCard>
              <ConditionIcon>📦</ConditionIcon>
              <ConditionTitle>Состояние товара</ConditionTitle>
              <ConditionDescription>
                Товар не должен быть в употреблении, должны быть сохранены товарный вид, 
                потребительские свойства, пломбы и фабричные ярлыки
              </ConditionDescription>
            </ConditionCard>
            <ConditionCard>
              <ConditionIcon>🧾</ConditionIcon>
              <ConditionTitle>Документы</ConditionTitle>
              <ConditionDescription>
                Необходимо наличие товарного чека, кассового чека или иного документа, 
                подтверждающего оплату товара
              </ConditionDescription>
            </ConditionCard>
          </ConditionsGrid>
        </SectionContent>
      </Section>

      <ImportantNote>
        <NoteTitle>Важные условия</NoteTitle>
        <NoteText>
          Администрация не несет ответственность за неполучение денежных средств, если они перечислены 
          по реквизитам, указанным в заявлении. При обнаружении некорректных реквизитов или подозрении 
          на мошенничество возврат может быть осуществлен альтернативным способом.
        </NoteText>
      </ImportantNote>

      <ContactInfo>
        <ContactTitle>Контакты для подачи заявления на возврат</ContactTitle>
        <ContactItem>
          <ContactLabel>Телефон:</ContactLabel>
          <ContactValue>+7 917 120-58-58</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>Адрес:</ContactLabel>
          <ContactValue>446301, Самарская область, г. Отрадный, Спортивная ул., д. 7</ContactValue>
        </ContactItem>
        <ContactItem>
          <ContactLabel>ИНН:</ContactLabel>
          <ContactValue>6318073403</ContactValue>
        </ContactItem>
      </ContactInfo>
    </ReturnsContainer>
  );
};

export default Returns; 